// mm:ss — switches to h:mm:ss past 1h. Used by both the in-call header
// timer (InCallSurface, lazy-loaded) and the call-ended toast (eager).
// Lives in its own tiny module so the eager toast can import it WITHOUT
// pulling InCallSurface (and its livekit-client transitive) back into
// the main bundle.

export function formatDuration(totalSec: number): string {
  const s = Math.max(0, Math.floor(totalSec))
  const h = Math.floor(s / 3600)
  const m = Math.floor((s % 3600) / 60)
  const ss = s % 60
  const mm = String(m).padStart(2, '0')
  const ssStr = String(ss).padStart(2, '0')
  return h > 0 ? `${h}:${mm}:${ssStr}` : `${mm}:${ssStr}`
}
